import Head from "next/head";

// Fallback only. Every route should pass its own `description` — a shared one
// across pages is what search engines treat as duplicate and ignore.
const SITE_DESCRIPTION =
  "The Immigration Gurus guide Indian students through studying abroad — university selection, applications, visa support and pre-departure preparation.";

const PageHead = ({ title, description = SITE_DESCRIPTION }) => {
  return (
    <>
      <Head>
        <title>{title}</title>
        <meta name="description" content={description} />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href="/favicon.ico" />

        {/* Google Ads gtag.js */}
        <script
          async
          src="https://www.googletagmanager.com/gtag/js?id=AW-18167992128"
        />
        <script
          dangerouslySetInnerHTML={{
            __html: `
              window.dataLayer = window.dataLayer || [];
              function gtag(){dataLayer.push(arguments);}
              gtag('js', new Date());
              gtag('config', 'AW-18167992128');
            `,
          }}
        />

        {/* Google Tag Manager */}
        <script
          dangerouslySetInnerHTML={{
            __html: `
              (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
              new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
              j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
              'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
              })(window,document,'script','dataLayer','GTM-KRHN5Q6S');
            `,
          }}
        />

        {/* Google Adsense */}
        <script
          async
          src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3022789600500774"
          crossOrigin="anonymous"
        />
      </Head>
    </>
  );
};

export default PageHead;
